/**
 * Road Type Helper Utilities
 * Utilities for determining road type labels and colors
 */

import type { TFunction } from 'i18next';

export type RoadTypeKey =
  | 'motorway'
  | 'expressway'
  | 'nationalRoad'
  | 'voivodeshipRoad'
  | 'road';

export interface RoadTypeInfo {
  label: string;
  color: string;
}

/**
 * Get road type label and color for display
 * @param roadType - The road type identifier
 * @param t - Translation function from i18next
 * @returns Object containing label and color for the road type
 */
export function getRoadType(roadType: string, t: TFunction): RoadTypeInfo {
  switch (roadType) {
    case 'motorway':
      return { label: t('roads.motorway'), color: 'blue' };
    case 'expressway':
      return { label: t('roads.expressway'), color: 'green' };
    case 'nationalRoad':
      return { label: t('roads.national'), color: 'red' };
    case 'voivodeshipRoad':
      return { label: t('roads.voivodeship'), color: 'orange' };
    default:
      return { label: t('roads.road'), color: 'gray' };
  }
}
